import {
  Alert,
  AlertIcon,
  Badge,
  Center,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Image,
  Modal,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tooltip,
  VStack,
  Wrap,
  WrapItem,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Button,
  Icon,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Tfoot,
  Box,
  Text,
  GridItem,
  Grid,
  Divider,
  Heading,
  Textarea,
  Input,
  Select,
} from "@chakra-ui/react";
import { MdDone, MdPhone } from "react-icons/md";
import { IoStorefront } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { FaRegAddressCard, FaTruck, FaUser } from "react-icons/fa";
import { MdSell } from "react-icons/md";
import { FaCalendarDays, FaShop } from "react-icons/fa6";
import { FaBarcode } from "react-icons/fa";
import { FaUserTag } from "react-icons/fa6";
import { IoEyeSharp } from "react-icons/io5";
import { MdDesignServices } from "react-icons/md";
import { MdMessage } from "react-icons/md";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { FaRoad } from "react-icons/fa6";
import { FaDollarSign } from "react-icons/fa";
import { LuHistory } from "react-icons/lu";
import { useAppContext } from "../context/AppContext";
import { useNavigate } from "react-router";
import fetchAgenda from "../apis/agenda-api";
import { MAX_LACRES } from "./lancamento-pedido-panel";
import LancamentoPedidoPanel from "./lancamento-pedido-panel";
import CarrinhoProdutosAtendimento from "./carrinho-produtos-atendimento";
import fetchCondPgtoCrm from "../apis/cond-pgto-crm-api";
import fetchVendedoresCrm from "../apis/vendedores-crm-api";
import fetchProdutosShellCrm from "../apis/produtos-shell-crm-api";
import fetchTransportadoras from "../apis/transportadoras-api";
import enviarPedidoVendas, {
  extractNumeroPedido,
} from "../apis/pedido-vendas-api";
import { BeatLoader } from "react-spinners";
import { MdContactPhone } from "react-icons/md";
import { GiMoneyStack } from "react-icons/gi";
import { FcDocument } from "react-icons/fc";
import { FcFinePrint } from "react-icons/fc";
import fetchHistoricoProdutos from "../apis/historico-pedidos-api";
import { format, subDays } from "date-fns";
import { BiShow } from "react-icons/bi";
import { FcDataConfiguration } from "react-icons/fc";
import { FcComboChart } from "react-icons/fc";
import { FaUserTie } from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";
import { GoHome } from "react-icons/go";
import { FaCity } from "react-icons/fa";
import { CiCalendarDate } from "react-icons/ci";

import historicoTitulos from "../apis/historico-titulos-api";
import fetchContatos from "../apis/contatos-api";
import fetchOperadores from "../apis/operadores-api";
import {
  SESSION_KEYS,
  contatosSessionKey,
  readSessionJson,
  writeSessionJson,
  hasCachedList,
  normalizeCondPgtoList,
  normalizeVendedoresList,
  normalizeProdutosShellList,
  normalizeTransportadorasList,
  TRANSPORTADORAS_API_ENABLED,
} from "../utils/atendimentoSessionCache";

import { useToast } from "@chakra-ui/react";

import NexusLogo from "../images/logo_nexus_consult.png";
import TabelaPedidos from "./tabela-historico-pedidos";
import UserDataHome from "./user-data-home";
import Footer from "./footer";

const Atendimento1 = () => {
  // const [rowItem, setSelectedItem] = useState(null);
  const [editedObservations, setEditedObservations] = useState({});
  const [date, setDate] = useState("");
  const [valoresSelecionados, setValoresSelecionados] = useState([]);
  const [descontoTotal, setDescontoTotal] = useState(0);
  const [transportadoras, setTransportadoras] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [condPagamentos, setCondPagamentos] = useState([]);
  const [vendedoresLista, setVendedoresLista] = useState([]);
  const [showAdditionalInputs, setShowAdditionalInputs] = useState(false);
  const [dadosAtendimento, setDadosAtendimento] = useState([]);
  const [condPagamentoSelecionado, setCondPagamentoSelecionado] = useState("");
  const [operacaoSelecionada, setOperacaoSelecionada] = useState("1");
  const [msgNotaSelecionada, setMsgNotaSelecionada] = useState("");
  const [obsAtendimentoSelecionada, setObsAtendimentoSelecionada] =
    useState("");
  const [tipoFreteSelecionado, setTipoFreteSelecionado] = useState("C");
  const [isLoading2, setIsLoading2] = useState(true);
  const [catalogosProntos, setCatalogosProntos] = useState(false);
  const [catalogosErro, setCatalogosErro] = useState(null);
  const [catalogosRetrying, setCatalogosRetrying] = useState(false);
  const [sessionTick, setSessionTick] = useState(0);

  const { rowItem, setRowItem } = useAppContext();
  const [transportadoraSelecionado, setTransportadoraSelecionada] = useState(
    rowItem?.codtransp || "",
  );
  const [obsClienteSelecionada, setObsSelecionada] = useState(
    rowItem?.observacao || "",
  );
  const [errorMessage, setErrorMessage] = useState(""); // Estado para armazenar a mensagem de erro
  const [responseData, setResponseData] = useState([]);

  const { globalToken } = useAppContext();

  const { dateGlobal, setDateGlobal, clienteCodigo } = useAppContext();
  const { username, setUsername } = useAppContext();
  const { password, setPassword } = useAppContext();
  const [dataInicialEstado, setDataInicialEstado] = useState("2000-01-01");
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda se o mês for menor que 10
    const day = String(today.getDate()).padStart(2, "0"); // Adiciona zero à esquerda se o dia for menor que 10
    return `${year}-${month}-${day}`;
  };

  const [dataInicialEstadoTitulos, setDataInicialEstadoTitulos] =
    useState("2000-01-01");

  const [dataFinalEstado, setDataFinalEstado] = useState(getCurrentDate());

  const [dataFinalEstadoTitulos, setDataFinalEstadoTitulos] =
    useState(getCurrentDate());

  const [dataInicial2, setDataInicial2] = useState("2000-01-01");
  const [dataFinal2, setDataFinal2] = useState(getCurrentDate());

  const [historicoProdutos, setHistoricoProdutos] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  const [contatos, setContatos] = useState([]);
  const [operadores, setOperadores] = useState([]);
  const [selectedOperador, setSelectedOperador] = useState("");
  const [selectedVendedor, setSelectedVendedor] = useState("");

  const [numeroAtendimento, setNumeroAtendimento] = useState(null);
  const [pedidoFinalizado, setPedidoFinalizado] = useState(null);

  const [veiculoSelecionado, setVeiculoSelecionado] = useState("");
  const [motoristaNome, setMotoristaNome] = useState("");
  const [motoristaId, setMotoristaId] = useState("");
  const [motoristaCpf, setMotoristaCpf] = useState("");

  const handleMotoristaFromFrota = (motorista) => {
    if (!motorista) {
      setMotoristaNome("");
      setMotoristaId("");
      setMotoristaCpf("");
      return;
    }
    setMotoristaNome(motorista.nome || "");
    setMotoristaId(motorista.id || "");
    setMotoristaCpf(motorista.cpf || "");
  };
  const [gerarBoleto, setGerarBoleto] = useState(false);
  const [lacres, setLacres] = useState([{ cor: "", numero: "" }]);

  const handleLacreChange = (index, field, value) => {
    setLacres((prev) =>
      prev.map((lacre, i) =>
        i === index ? { ...lacre, [field]: value } : lacre,
      ),
    );
  };

  const handleAddLacre = () => {
    setLacres((prev) =>
      prev.length >= MAX_LACRES ? prev : [...prev, { cor: "", numero: "" }],
    );
  };

  const handleRemoveLacre = (index) => {
    setLacres((prev) =>
      prev.length <= 1 ? prev : prev.filter((_, i) => i !== index),
    );
  };
  const [tipoSaida, setTipoSaida] = useState("");
  const [abaAtiva, setAbaAtiva] = useState(0);
  const [volumeBocas, setVolumeBocas] = useState([]);
  const [parcelasVencimento, setParcelasVencimento] = useState([]);

  const toast = useToast();
  const navigate = useNavigate();

  const storedTransportadoras = sessionStorage.getItem(
    SESSION_KEYS.TRANSPORTADORAS,
  );
  const storedCondPagamentos = sessionStorage.getItem(SESSION_KEYS.COND_PGTO);
  const storedOperadores = sessionStorage.getItem("operadores");
  const storedVendedores = sessionStorage.getItem(SESSION_KEYS.VENDEDORES);
  // sessionTick força releitura do sessionStorage após gravar catálogos
  void sessionTick;

  // Função auxiliar para parse seguro
  const safeParse = (value, defaultValue = []) => {
    try {
      if (!value) return defaultValue;
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : defaultValue;
    } catch (error) {
      console.error("Erro ao fazer parse:", error);
      return defaultValue;
    }
  };

  const parsedTransportadoras =
    Array.isArray(transportadoras) && transportadoras.length > 0
      ? transportadoras
      : safeParse(storedTransportadoras);
  const parsedCondPagamentos =
    Array.isArray(condPagamentos) && condPagamentos.length > 0
      ? condPagamentos
      : safeParse(storedCondPagamentos);
  const parsedOperadores = safeParse(storedOperadores);
  const parsedVendedores =
    Array.isArray(vendedoresLista) && vendedoresLista.length > 0
      ? vendedoresLista
      : safeParse(storedVendedores);

  const checkUser = () => {
    if (username === "" || password === "") {
      navigate("/error"); // Limpar selectedItem ao clicar no botão Voltar
    }
  };

  checkUser();

  // Verificar rowItem ao montar o componente
  useEffect(() => {
    if (!rowItem || !rowItem.codigo) {
      console.log("Cliente selecionado: codigo", rowItem?.codigo);
      navigate("/atendimento"); // Redireciona se não houver cliente selecionado
    }
  }, [rowItem, navigate]);

  // const closeModal = () => {
  //   setSelectedItem(null);
  // };

  // Função para atualizar a observação do cliente
  const updateObservation = (id, observation) => {
    setEditedObservations({ ...editedObservations, [id]: observation });
  };

  const handleChangeInputDate = (e) => {
    let input = e.target.value;
    // Remove tudo que não for número
    input = input.replace(/\D/g, "");

    // Verifica se a data possui menos de 8 dígitos
    if (input.length <= 8) {
      // Adiciona as barras de acordo com o tamanho da string
      if (input.length > 2 && input.length <= 4) {
        input = input.replace(/(\d{2})(\d{2})/, "$1/$2");
      } else if (input.length > 4) {
        input = input.replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");
      }
      // Atualiza o estado
      setDate(input);
    }
  };
  const dataAtual = new Date();

  // Obtém as horas, minutos e segundos
  const horas = dataAtual.getHours();
  const minutos = dataAtual.getMinutes();
  const segundos = dataAtual.getSeconds();

  // Formata a hora para exibição com dois dígitos (por exemplo, '09' em vez de '9')
  const horasFormatadas = horas < 10 ? "0" + horas : horas;
  const minutosFormatados = minutos < 10 ? "0" + minutos : minutos;
  const segundosFormatados = segundos < 10 ? "0" + segundos : segundos;

  const horarioAtual = `${horasFormatadas}:${minutosFormatados}:${segundosFormatados}`;

  const tipoFreteOptions = [
    { value: "C", label: "CIF" },
    { value: "F", label: "FOB" },
    { value: "T", label: "Terceiros" },
    { value: "R", label: "Remetente" },
    { value: "D", label: "Destinatário" },
    { value: "S", label: "Sem cobrança de frete" },
  ];

  const tipoOperacaoOptions = [
    { value: "1", label: "Faturamento" },
    { value: "2", label: "Orçamento" },
    { value: "3", label: "Atendimento" },
  ];

  const customStyles = {
    control: {
      backgroundColor: "transparent",
      borderColor: "green.500", // Altera a cor da borda quando o controle está focado
    },
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "green.500" : "white", // Define a cor de fundo das opções selecionadas como verde e as não selecionadas como branca
      color: state.isSelected ? "white" : "black", // Define a cor do texto das opções selecionadas como branco e as não selecionadas como preto
      "&:hover": {
        backgroundColor: "lightgreen", // Define a cor de fundo ao passar o mouse sobre as opções
      },
    }),
  };

  const handleBackButtonClick = async () => {
    //   try {
    //     const agendaData = await fetchAgenda(
    //       dateGlobal,
    //       globalToken.access_token
    //     ); // Chame fetchAgenda com dateGlobal
    //     // Faça o que você precisa com os dados retornados, por exemplo, definir o estado ou realizar outras operações
    //     console.log(agendaData);
    //   } catch (error) {
    //     console.error("Erro ao buscar a agenda:", error);
    //     // Verificar se o erro é de autorização (401 Unauthorized)
    //     if (error.response && error.response.status === 401) {
    //       // Solicitar um novo token de acesso
    //       try {
    //         const newToken = await fetchToken(username, password);
    //         // Refazer a chamada à função fetchAgenda com o novo token de acesso
    //         const agendaData = await fetchAgenda(
    //           dateGlobal,
    //           newToken.access_token
    //         );
    //         // Faça o que você precisa com os dados retornados
    //         console.log(agendaData);
    //       } catch (error) {
    //         console.error("Erro ao obter novo token de acesso:", error);
    //         // Lidar com o erro ao obter o novo token de acesso
    //       }
    //     } else {
    //       // Lidar com outros tipos de erro
    //     }
    //   }
    navigate("/atendimento"); // Limpar selectedItem ao clicar no botão Voltar
  };

  const handleFinalizarAddProdutos = useCallback((valores) => {
    setValoresSelecionados(valores);
  }, []);

  const obterDataAtual = () => {
    const data = new Date();
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();
    return `${ano}-${mes}-${dia}`; // Formato do input type "date" é yyyy-mm-dd
  };

  // Função para calcular o total da quantidade
  const calcularTotalQuantidade = () => {
    return valoresSelecionados.reduce(
      (total, produto) => total + produto.quantidade,
      0,
    );
  };

  // Função para calcular o total do valor total
  const calcularTotalValorTotal = () => {
    return valoresSelecionados.reduce(
      (total, produto) => total + produto.precoTotal,
      0,
    );
  };

  const handleDescontoChange = (index, desconto) => {
    setValoresSelecionados((prevState) =>
      prevState.map((produto, i) =>
        i === index ? { ...produto, desconto: desconto } : produto,
      ),
    );
  };

  const handleDescontoTotalChange = (e) => {
    setDescontoTotal(e.target.value);
  };

  const calcularPrecoTotalComDesconto = (precoTotal, desconto) => {
    const valorDesconto = (precoTotal * desconto) / 100;
    return precoTotal - valorDesconto;
  };

  const calcularPrecoTotal = (quantidade, precoUnitario, desconto) => {
    // Verifica se o desconto é um número válido, se não for, define como zero
    if (isNaN(desconto)) {
      desconto = 0;
    }

    const precoTotal = quantidade * precoUnitario;
    return calcularPrecoTotalComDesconto(precoTotal, desconto);
  };

  const calcularPrecoTotalGeral = () => {
    let precoTotalGeral = 0;
    valoresSelecionados.forEach((produto) => {
      precoTotalGeral +=
        calcularPrecoTotal(
          produto.quantidade,
          produto.precoUnitario,
          produto.desconto,
        ) || 0;
    });
    const descontoTotalDecimal = descontoTotal / 100;
    precoTotalGeral *= 1 - descontoTotalDecimal;
    return precoTotalGeral;
  };

  const getCondPagamentos = async (token = globalToken?.access_token) => {
    const response = await fetchCondPgtoCrm({
      token,
      username,
      password,
    });
    const items = normalizeCondPgtoList(response);
    if (!items.length) {
      throw new Error(
        "API de condição de pagamento retornou lista vazia ou em formato inesperado.",
      );
    }
    writeSessionJson(SESSION_KEYS.COND_PGTO, items);
    setCondPagamentos(items);
    return items;
  };

  const getVendedoresCrm = async (token = globalToken?.access_token) => {
    const response = await fetchVendedoresCrm({
      token,
      username,
      password,
    });
    const items = normalizeVendedoresList(response);
    if (!items.length) {
      throw new Error(
        "API de vendedores retornou lista vazia ou em formato inesperado.",
      );
    }
    writeSessionJson(SESSION_KEYS.VENDEDORES, items);
    setVendedoresLista(items);
    return items;
  };

  const getProdutosShellCrm = async (token = globalToken?.access_token) => {
    const response = await fetchProdutosShellCrm({
      token,
      username,
      password,
    });
    const items = normalizeProdutosShellList(response);
    writeSessionJson(SESSION_KEYS.PRODUTOS_SHELL, items);
    return items;
  };

  const getTransportadoras = async (token = globalToken?.access_token) => {
    const response = await fetchTransportadoras(token, username, password);
    const items = normalizeTransportadorasList(response);
    if (!items.length) {
      throw new Error(
        "API de transportadoras retornou lista vazia ou em formato inesperado.",
      );
    }
    writeSessionJson(SESSION_KEYS.TRANSPORTADORAS, items);
    setTransportadoras(items);
    return items;
  };

  const getHistoricoProdutos = async (
    clienteHistPedidos = rowItem.codigo,
    dataInicial,
    dataFinal,
    token = globalToken.access_token,
    codLoja,
  ) => {
    setIsLoading(true);
    // const today = format(new Date(), "dd/MM/yyyy");
    // const ninetyDaysAgo = format(subDays(new Date(), 90), "dd/MM/yyyy");
    try {
      const response = await fetchHistoricoProdutos(
        (clienteHistPedidos = rowItem.codigo),
        (dataInicial = dataInicialEstado),
        (dataFinal = dataFinalEstado),
        (token = globalToken.access_token),
        (codLoja = rowItem["loja  "]),
        username,
        password,
      );
      setHistoricoProdutos(response);
    } catch (error) {
      console.error("Erro ao buscar histórico de pedidos:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getContatos = async (opts = {}) => {
    const cliente = opts.cliente ?? rowItem?.codigo;
    const loja = opts.loja || "01";
    if (!cliente) return;

    const cacheKey = contatosSessionKey(cliente, loja);
    const cached = readSessionJson(cacheKey);
    if (Array.isArray(cached)) {
      setContatos(cached);
      return cached;
    }

    try {
      const data = await fetchContatos({
        empresa: opts.empresa || "01",
        filial: opts.filial || "01",
        page: opts.page || 1,
        pageSize: opts.pageSize || 10000,
        cliente,
        loja,
        token: opts.token || globalToken.access_token,
        username: opts.username ?? username,
        password: opts.password ?? password,
      });

      const items = Array.isArray(data?.items) ? data.items : [];
      writeSessionJson(cacheKey, items);
      setContatos(items);
      return items;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const loadCatalogosObrigatorios = async (tokenOverride) => {
    const token = tokenOverride || globalToken?.access_token;
    if (!token) {
      throw new Error("Token de autenticação indisponível.");
    }

    const runWithAuthRetry = (fn) => fn(token);

    const labeledTasks = [];

    // Re-normaliza cache antigo de vendedores (codigo_vededor → codigo)
    if (sessionStorage.getItem(SESSION_KEYS.VENDEDORES) != null) {
      const rawVend = readSessionJson(SESSION_KEYS.VENDEDORES, []);
      const migrated = normalizeVendedoresList(rawVend);
      if (migrated.length > 0) {
        writeSessionJson(SESSION_KEYS.VENDEDORES, migrated);
      } else {
        sessionStorage.removeItem(SESSION_KEYS.VENDEDORES);
      }
    }

    if (!hasCachedList(SESSION_KEYS.COND_PGTO)) {
      labeledTasks.push({
        label: "condição de pagamento",
        run: () => runWithAuthRetry((t) => getCondPagamentos(t)),
      });
    }
    if (!hasCachedList(SESSION_KEYS.VENDEDORES)) {
      labeledTasks.push({
        label: "vendedores",
        run: () => runWithAuthRetry((t) => getVendedoresCrm(t)),
      });
    }
    if (!hasCachedList(SESSION_KEYS.PRODUTOS_SHELL)) {
      labeledTasks.push({
        label: "produtos",
        run: () => runWithAuthRetry((t) => getProdutosShellCrm(t)),
      });
    }
    if (
      TRANSPORTADORAS_API_ENABLED &&
      !hasCachedList(SESSION_KEYS.TRANSPORTADORAS)
    ) {
      labeledTasks.push({
        label: "transportadoras",
        run: () => runWithAuthRetry((t) => getTransportadoras(t)),
      });
    }

    if (labeledTasks.length > 0) {
      const results = await Promise.allSettled(
        labeledTasks.map((t) => t.run()),
      );
      const failedLabels = results
        .map((r, i) => (r.status === "rejected" ? labeledTasks[i].label : null))
        .filter(Boolean);
      if (failedLabels.length > 0) {
        throw new Error(`Falha ao carregar: ${failedLabels.join(", ")}.`);
      }
    }

    // Hidrata estado local a partir do cache (mesmo quando já existia)
    const cond = readSessionJson(SESSION_KEYS.COND_PGTO, []);
    if (Array.isArray(cond)) setCondPagamentos(cond);
    const vend = readSessionJson(SESSION_KEYS.VENDEDORES, []);
    if (Array.isArray(vend)) setVendedoresLista(vend);
    const transp = readSessionJson(SESSION_KEYS.TRANSPORTADORAS, []);
    if (Array.isArray(transp)) setTransportadoras(transp);

    setSessionTick((n) => n + 1);
  };

  const getOperadores = async () => {
    try {
      const data = await fetchOperadores({
        empresa: "01",
        filial: "01",
        token: globalToken.access_token,
        username,
        password,
      });

      setOperadores(data.items);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!rowItem?.codigo || !globalToken?.access_token) return;

    let cancelled = false;

    const fetchApis = async () => {
      setIsLoading2(true);
      setCatalogosErro(null);
      setCatalogosRetrying(false);

      try {
        await loadCatalogosObrigatorios(globalToken.access_token);

        try {
          await getContatos({
            empresa: "01",
            filial: "01",
            page: 1,
            pageSize: 10000,
            cliente: rowItem.codigo,
            loja: "01",
            token: globalToken.access_token,
            username,
            password,
          });
        } catch (contatosError) {
          console.error("Erro ao buscar contatos:", contatosError);
        }

        if (!cancelled) {
          setCatalogosProntos(true);
        }
      } catch (error) {
        console.error("Erro ao buscar APIs do atendimento:", error);
        if (!cancelled) {
          setCatalogosProntos(false);
          setCatalogosErro(
            error?.message ||
              "Falha ao carregar catálogos (condição de pagamento, vendedores ou produtos).",
          );
        }
      } finally {
        if (!cancelled) {
          setIsLoading2(false);
        }
      }
    };

    fetchApis();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowItem?.codigo, globalToken?.access_token]);

  const handleRetryCatalogos = async () => {
    setCatalogosRetrying(true);
    setCatalogosErro(null);
    setIsLoading2(true);
    try {
      await loadCatalogosObrigatorios(globalToken?.access_token);
      try {
        await getContatos({
          empresa: "01",
          filial: "01",
          page: 1,
          pageSize: 10000,
          cliente: rowItem.codigo,
          loja: "01",
          token: globalToken.access_token,
          username,
          password,
        });
      } catch (contatosError) {
        console.error("Erro ao buscar contatos:", contatosError);
      }
      setCatalogosProntos(true);
    } catch (error) {
      console.error("Retry catálogos falhou:", error);
      setCatalogosProntos(false);
      setCatalogosErro(
        error?.message ||
          "Falha ao carregar catálogos (condição de pagamento, vendedores ou produtos).",
      );
    } finally {
      setCatalogosRetrying(false);
      setIsLoading2(false);
    }
  };

  useEffect(() => {
    const precoTotalGeral = calcularPrecoTotalGeral();
    // Faça o que for necessário com o preço total geral recalculado, como atualizar o estado ou enviar para a API
  }, [valoresSelecionados, descontoTotal]);

  // Carregar histórico de compras automaticamente quando a página abrir
  useEffect(() => {
    if (
      rowItem &&
      rowItem.codigo &&
      globalToken &&
      globalToken.access_token &&
      dataInicialEstado &&
      dataFinalEstado
    ) {
      getHistoricoProdutos(
        rowItem.codigo,
        dataInicialEstado,
        dataFinalEstado,
        globalToken.access_token,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowItem?.codigo, globalToken?.access_token]);

  const handleCondPagamentoChange = (event) => {
    const selectedOption = event.target.value;
    setShowAdditionalInputs(selectedOption === "999");
    setCondPagamentoSelecionado(event.target.value);
    if (selectedOption !== "999") {
      setParcelasVencimento([]);
    }
  };

  const handleTransportadora = (event) => {
    setTransportadoraSelecionada(event.target.value);
  };

  const handleOperacao = (event) => {
    setOperacaoSelecionada(event.target.value);
  };

  const handleMsgNota = (event) => {
    // Obtém o valor do campo de texto e atualiza o estado
    setMsgNotaSelecionada(event.target.value);
  };

  const handleObsCliente = (event) => {
    // Obtém o valor do campo de texto e atualiza o estado
    setObsSelecionada(event.target.value);
  };

  const handleObsAtendimento = (event) => {
    // Obtém o valor do campo de texto e atualiza o estado
    setObsAtendimentoSelecionada(event.target.value);
  };

  const handleTipoFrete = (event) => {
    // Obtém o valor do campo de texto e atualiza o estado
    setTipoFreteSelecionado(event.target.value);
  };

  const handleRemoveItem = (itemToRemove) => {
    // Filtra os valores selecionados, removendo o item a ser removido
    const novosValoresSelecionados = valoresSelecionados.filter(
      (item) => item !== itemToRemove,
    );
    setValoresSelecionados(novosValoresSelecionados);
  };

  const isButtonDisabled = () => {
    let disabled = false;
    let messages = [];

    if (!condPagamentoSelecionado) {
      messages.push("Condição de pagamento está vazio ou indefinido.");
      disabled = true;
    }
    if (
      (operacaoSelecionada === "1" || operacaoSelecionada === "2") &&
      valoresSelecionados.length === 0
    ) {
      messages.push(
        "Não é possível finalizar um atendimento com este tipo de operação sem produtos adicionados.",
      );
      disabled = true;
    }
    if (!operacaoSelecionada) {
      messages.push("Operação está vazio ou indefinido.");
      disabled = true;
    }
    if (!selectedVendedor) {
      messages.push("Vendedor está vazio ou indefinido.");
      disabled = true;
    }
    if (!veiculoSelecionado) {
      messages.push("Veículo está vazio ou indefinido.");
      disabled = true;
    }
    if (!obsAtendimentoSelecionada) {
      messages.push("Observação do atendimento está vazio ou indefinido.");
      disabled = true;
    }
    if (TRANSPORTADORAS_API_ENABLED && !transportadoraSelecionado) {
      messages.push("Transportadora está vazio ou indefinido.");
      disabled = true;
    }
    if (!tipoFreteSelecionado) {
      messages.push("Tipo do frete está vazio ou indefinido.");
      disabled = true;
    }

    return { disabled, messages };
  };

  const codigoDoContato = contatos.length > 0 ? contatos[0].codigo : "";

  const bodyApi = {
    cliente: String(rowItem.codigo || "").trim(),
    loja: String(rowItem["loja  "] || rowItem.loja || "01").trim() || "01",
    contato: String(codigoDoContato || "").trim(),
    vendedor: String(selectedVendedor || "").trim(),
    operador: "",
    condpag: String(condPagamentoSelecionado || "").trim(),
    tabela: "L02",
    operacao: String(operacaoSelecionada || "").trim(),
    msgNota: msgNotaSelecionada || "",
    obsCliente: obsClienteSelecionada || "",
    dataLigacao: obterDataAtual(),
    horaLigacao: horarioAtual,
    obsAtendimento: obsAtendimentoSelecionada || "",
    transportadora: String(transportadoraSelecionado || "").trim(),
    tipoFrete: String(tipoFreteSelecionado || "").trim(),
    tipoCliente: "F",
    comprador: String(rowItem.codigo || "").trim(),
    veiculo: veiculoSelecionado || "",
    motorista: motoristaNome || "",
    motoristaId: motoristaId || "",
    motoristaCpf: motoristaCpf || "",
    gera_boleto: gerarBoleto ? "S" : "N",
    lacres: lacres.filter((l) => l.cor || String(l.numero || "").trim()),
    corLacre:
      lacres.find((l) => l.cor || String(l.numero || "").trim())?.cor || "",
    nmrLacre:
      lacres.find((l) => l.cor || String(l.numero || "").trim())?.numero || "",
    tipoSaida: tipoSaida || "",
    volumesBocas: Array.isArray(volumeBocas) ? volumeBocas : [],
    parcelasVencimento: Array.isArray(parcelasVencimento)
      ? parcelasVencimento
      : [],
    produtos: valoresSelecionados.map((produto) => {
      const qtd = Number(produto.quantidade) || 0;
      const precoUnitarioComDesconto =
        qtd > 0
          ? calcularPrecoTotal(
              produto.quantidade,
              produto.precoUnitario,
              produto.desconto,
            ) / qtd
          : Number(produto.precoUnitario) || 0;
      return {
        produto: String(produto.codigo || "").trim(),
        quant: qtd,
        valorUnit: Number(Number(precoUnitarioComDesconto).toFixed(6)),
      };
    }),
  };

  const handleClickFinalizaAtendimento = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      const resposta = await enviarPedidoVendas(
        bodyApi,
        globalToken.access_token,
        username,
        password,
        { empresa: "01", filial: "01" },
      );
      setIsLoading(false);

      const numeroPedido = extractNumeroPedido(resposta);

      if (numeroPedido !== "") {
        setNumeroAtendimento(numeroPedido);
        setPedidoFinalizado(numeroPedido);
        toast({
          title: "Pedido gerado com sucesso",
          description: `Número do pedido: ${numeroPedido}`,
          status: "success",
          duration: 6000,
          isClosable: true,
        });
      } else {
        console.warn("CRM_INCPV sucesso sem numero_pedido:", resposta);
        setNumeroAtendimento("");
        setPedidoFinalizado("—");
        toast({
          title: "Pedido enviado",
          description:
            "A API não retornou numero_pedido. Verifique no Protheus.",
          status: "warning",
          duration: 6000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Erro ao finalizar CRM_INCPV:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message &&
        String(error.response.data.message).includes(
          "Quantidade de campos retornado pelo bloco de carga do modelo:DATASTORAGE, é menor que a quantidade de campos na estrutura. Verifique o bloco de carga",
        )
      ) {
        console.log(
          "Tentando novamente devido ao erro de quantidade de campos...",
        );
        handleClickFinalizaAtendimento();
      } else if (error.sessionExpired) {
        setIsLoading(false);
      } else if (error.userMessage) {
        setErrorMessage({ code: error.response?.status, message: error.userMessage });
      } else if (error.response && error.response.data) {
        setErrorMessage(error.response.data);
      } else {
        setErrorMessage({
          code: "",
          message:
            error.message || "Erro ao enviar pedido de venda. Tente novamente.",
        });
      }
      setIsLoading(false);
    }
  };

  const irParaHome = () => {
    setPedidoFinalizado(null);
    navigate("/home");
  };

  const [dataError, setDataError] = useState("");
  const [dataAtualEstad, setDataAtualEstad] = useState(obterDataAtual());

  const handleDataAtualChange = (e) => {
    const newData = e.target.value;
    setDataAtualEstad(newData);
    if (!validarFormatoData(newData)) {
      setDataError("Formato de data inválido. Use dd/mm/aaaa");
    } else {
      setDataError("");
    }
  };

  const validarFormatoData = (data) => {
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;
    return regex.test(data);
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Previne o comportamento padrão do formulário
    getHistoricoProdutos(
      rowItem.codigo,
      dataInicialEstado,
      dataFinalEstado,
      globalToken.access_token,
      rowItem["loja  "],
    );
  };

  const handleSubmit2 = (event) => {
    event.preventDefault(); // Previne o comportamento padrão do formulário
  };

  const [showTipo, setShowTipo] = useState("NF");

  const pedidosFiltrados = historicoProdutos.filter((pedido) =>
    showTipo === "NF" ? pedido.tipo === "NF" : pedido.tipo !== "NF",
  );

  const [selectedPedido, setSelectedPedido] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen2, onOpen2, onClose2 } = useDisclosure();
  const [isLoading3, setIsLoading3] = useState(false); // Alterado para false inicialmente
  const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);

  const handleRowClick = (pedido) => {
    setSelectedPedido(pedido);
    onOpen();
  };

  const handleSubmit3 = async (situacao, title) => {
    const emissaoInicial = dataInicial2;
    const emissaoFinal = dataFinal2;
    const vencimentoInicial = "";
    const vencimentoFinal = "";
    const codigoCliente = rowItem.codigo;
    const loja = rowItem["loja  "];
    const token = globalToken.access_token;

    setIsLoading3(true);

    try {
      const responseApi = await historicoTitulos(
        token,
        codigoCliente,
        loja,
        emissaoInicial,
        emissaoFinal,
        vencimentoInicial,
        vencimentoFinal,
        situacao,
        username,
        password,
      );

      setModalTitle(title);
      setResponseData(responseApi);
      setIsResponseModalOpen(false);
      setIsLoading3(false);
    } catch (error) {
      console.error("Erro ao fazer a requisição:", error);
      setResponseData({ error: error.userMessage || error.message });
      setIsResponseModalOpen(false);
      setIsLoading3(false);
    }
    setIsLoading3(false);
  };

  const handleSelectChangeVendedores = (event) => {
    const selectedCodigo = event.target.value;
    setSelectedVendedor(selectedCodigo);
  };

  const { disabled, messages } = isButtonDisabled();

  // Função para converter a data no formato "DD/MM/YYYY" para um objeto Date
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  // Ordenar os pedidos pela data de emissão (do mais recente para o mais antigo)
  const pedidosOrdenados = [...historicoProdutos].sort(
    (a, b) => parseDate(b.emissao) - parseDate(a.emissao),
  );

  function formatarData(data) {
    if (!data) return ""; // Retorna vazio se a data for inválida

    // Se a data já está no formato ISO (YYYY-MM-DD), parsear diretamente
    if (typeof data === "string" && data.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    }

    // Caso contrário, tentar parsear como Date
    try {
      const dataFormatada = new Date(data);

      // Verificar se a data é válida
      if (isNaN(dataFormatada.getTime())) {
        return data; // Retorna o valor original se não for uma data válida
      }

      const dia = String(dataFormatada.getDate()).padStart(2, "0");
      const mes = String(dataFormatada.getMonth() + 1).padStart(2, "0");
      const ano = dataFormatada.getFullYear();

      return `${dia}/${mes}/${ano}`;
    } catch (error) {
      return data; // Retorna o valor original em caso de erro
    }
  }

  const parseDate2 = (dateStr) => {
    const [day, month, year] = dateStr.split("/");
    return new Date(year, month - 1, day); // O mês no JavaScript começa de 0, por isso subtraímos 1
  };

  // Função para zerar as horas de uma data (mantém apenas DD/MM/YYYY)
  const removeTimeFromDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()); // Remove horas, minutos e segundos
  };

  // Data atual sem horas
  const currentDate = removeTimeFromDate(new Date());

  // Verifica se responseData é um array antes de aplicar o .filter()
  const filteredItems = Array.isArray(responseData)
    ? responseData.filter(
        (item) =>
          removeTimeFromDate(parseDate2(item.vencimento)) < currentDate &&
          item.dt_baixa === "  /  /    ",
      )
    : []; // Se não for um array, retorna um array vazio ou outra lógica de fallback

  if (!Array.isArray(responseData)) {
    // Caso o responseData não seja um array, você pode lidar com o erro aqui
    console.error(
      "Erro na resposta da API:",
      responseData.errorMessage || "Erro desconhecido",
    );
  }

  // Contar quantidade de itens filtrados
  const filteredItemsCount = filteredItems.length;

  const isValidDate = (date) => {
    const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    return regex.test(date);
  };

  const titulosDatesValid =
    isValidDate(dataInicial2) && isValidDate(dataFinal2);

  const getTitulosBtnProps = (tituloLabel) => {
    const isActive = modalTitle === tituloLabel;

    return {
      isLoading: isLoading3,
      size: "sm",
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      flex: { base: 1, md: "none" },
      borderRadius: "lg",
      transition: "all 0.2s",
      border: "2px solid",
      borderColor: isActive ? "#007abe" : "gray.200",
      bg: isActive ? "#007abe" : "white",
      color: isActive ? "white" : "#007abe",
      boxShadow: isActive ? "md" : "sm",
      _hover: {
        bg: isActive ? "#005a8a" : "gray.50",
        borderColor: "#007abe",
        transform: titulosDatesValid ? "translateY(-2px)" : "none",
        boxShadow: titulosDatesValid ? "md" : "sm",
      },
      _disabled: {
        bg: "gray.100",
        borderColor: "gray.200",
        color: "gray.400",
        cursor: "not-allowed",
        opacity: 0.7,
      },
      isDisabled: !titulosDatesValid,
    };
  };

  // Verificar se rowItem existe antes de renderizar
  if (!rowItem || !rowItem.codigo) {
    return (
      <Box p={8} textAlign="center">
        <Text fontSize="xl" mb={4}>
          Nenhum cliente selecionado
        </Text>
        <Button onClick={() => navigate("/atendimento")} colorScheme="blue">
          Voltar para atendimento
        </Button>
      </Box>
    );
  }

  if (!catalogosProntos) {
    return (
      <Flex direction="column" minH="100vh" bg="gray.50">
        <UserDataHome />
        <Box flex="1" py={{ base: 4, md: 6 }} px={{ base: 4, md: 6 }}>
          <Box maxW={{ base: "100%", lg: "1600px" }} mx="auto">
            <Flex justify="space-between" align="center" mb={6}>
              <Button
                onClick={handleBackButtonClick}
                colorScheme="red"
                variant="outline"
                leftIcon={<GoHome />}
              >
                Voltar
              </Button>
            </Flex>
            <Center minH="50vh" flexDirection="column" gap={4}>
              {(isLoading2 || catalogosRetrying) && (
                <>
                  <Spinner size="xl" color="#007abe" thickness="4px" />
                  <Text color="gray.600" fontWeight="medium">
                    Carregando dados do atendimento...
                  </Text>
                </>
              )}
            </Center>
          </Box>
        </Box>
        <Modal
          isOpen={Boolean(catalogosErro)}
          onClose={() => {}}
          isCentered
          closeOnOverlayClick={false}
          closeOnEsc={false}
        >
          <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
          <ModalContent borderRadius="xl">
            <ModalHeader color="#007abe">
              Não foi possível carregar os dados
            </ModalHeader>
            <ModalBody>
              <Text mb={3}>
                Uma ou mais APIs essenciais falharam (condição de pagamento,
                vendedores ou produtos). A página só será liberada após o
                carregamento com sucesso.
              </Text>
              <Text fontSize="sm" color="gray.600">
                {catalogosErro}
              </Text>
            </ModalBody>
            <ModalFooter>
              <Button variant="outline" mr={3} onClick={handleBackButtonClick}>
                Voltar
              </Button>
              <Button
                bg="#007abe"
                color="white"
                _hover={{ bg: "#0066a3" }}
                onClick={handleRetryCatalogos}
                isLoading={catalogosRetrying}
              >
                Tentar novamente
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Footer />
      </Flex>
    );
  }

  return (
    <Flex direction="column" minH="100vh" bg="gray.50">
      <UserDataHome />
      <Box flex="1" py={{ base: 4, md: 6 }} px={{ base: 4, md: 6 }}>
        <Box maxW={{ base: "100%", lg: "1600px" }} mx="auto">
          <Flex justify="space-between" align="center" mb={6}>
            <Button
              onClick={handleBackButtonClick}
              colorScheme="red"
              variant="outline"
              leftIcon={<GoHome />}
              _hover={{
                bg: "red.50",
                transform: "translateY(-2px)",
                boxShadow: "md",
              }}
              transition="all 0.2s"
            >
              Voltar
            </Button>
          </Flex>
          {/* <Box
          bg="#2C0E37"
          color="white"
          mb={3}
          p={1}
          borderRadius={5}
          shadow="lg"
        >
          <HStack></HStack>
          <Divider w={520} mt={1} borderWidth={2} />
        </Box> */}

          <Tabs
            colorScheme="blue"
            size="md"
            variant="enclosed"
            mb={6}
            index={abaAtiva}
            onChange={setAbaAtiva}
          >
            <TabList
              bg="white"
              borderRadius="lg"
              p={1}
              boxShadow="sm"
              border="1px solid"
              borderColor="gray.200"
            >
              <Tab
                _selected={{
                  color: "white",
                  bg: "#007abe",
                  fontWeight: "bold",
                }}
                _hover={{ bg: "gray.100" }}
                borderRadius="md"
                mr={1}
              >
                <Box mr={2}>
                  <MdContactPhone />
                </Box>
                Atendimento
              </Tab>
              <Tab
                _selected={{
                  color: "white",
                  bg: "#007abe",
                  fontWeight: "bold",
                }}
                _hover={{ bg: "gray.100" }}
                borderRadius="md"
                mr={1}
              >
                <Box mr={2}>
                  <GiMoneyStack />
                </Box>
                Financeiro
              </Tab>
              <Tab
                _selected={{
                  color: "white",
                  bg: "#007abe",
                  fontWeight: "bold",
                }}
                _hover={{ bg: "gray.100" }}
                borderRadius="md"
              >
                <Box mr={2}>
                  <FaTruck />
                </Box>
                Pedido
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                {abaAtiva === 0 && rowItem && (
                  <>
                    {/* <Box
                bg="#2C0E37"
                color="white"
                mb={3}
                p={1}
                borderRadius={5}
                shadow="lg"
              >
                <Text size="4xl" mb="25px" ml={3}>
                  <strong>{`Operador: ${rowItem.nomeOperador} - ${rowItem.codOperador} - Lista: ${rowItem.codLista}`}</strong>
                  <Divider w={520} mt={1} borderWidth={2} />
                </Text>
              </Box> */}
                    <Grid
                      templateColumns={{ base: "1fr", lg: "repeat(2, 1fr)" }}
                      gap={6}
                      mb={6}
                    >
                      <GridItem>
                        {isLoading2 ? (
                          <Center h="400px">
                            <Spinner size="xl" color="#007abe" />
                          </Center>
                        ) : (
                          <Box
                            bg="white"
                            p={6}
                            borderRadius="xl"
                            boxShadow="md"
                            border="1px solid"
                            borderColor="gray.200"
                            h="100%"
                            display="flex"
                            flexDirection="column"
                            _hover={{
                              transform: "translateY(-4px)",
                              boxShadow: "xl",
                              borderColor: "#007abe",
                            }}
                            transition="all 0.3s"
                          >
                            <Flex
                              align="center"
                              mb={4}
                              justify="flex-start"
                              wrap="wrap"
                            >
                              <Text
                                fontSize="lg"
                                fontWeight="bold"
                                color="#007abe"
                                display="flex"
                                alignItems="center"
                              >
                                <Icon as={FaUser} mr={2} color="#c0a316" />{" "}
                                Contato:
                              </Text>
                              <Text
                                color="gray.700"
                                fontSize="md"
                                fontWeight="semibold"
                              >
                                {rowItem.contato}
                              </Text>
                            </Flex>
                            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                              {/* Coluna Esquerda */}
                              <Box>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={MdPhone}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Tel
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  ({rowItem.ddd}) {rowItem.telefone}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={MdPhone}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Tel II
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem.celular}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={IoStorefront}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Cliente
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem.nome}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  mb={1}
                                >
                                  CNPJ:
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem.cnpj}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  mb={1}
                                >
                                  Inscrição Estadual:
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem.increst ||
                                    rowItem.inscricao_estadual ||
                                    rowItem.INSCRICAO_ESTADUAL ||
                                    rowItem.inscricaoEstadual ||
                                    "N/A"}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={FaDollarSign}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Limite de Crédito:
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem.limitecredito !== undefined &&
                                  rowItem.limitecredito !== null &&
                                  rowItem.limitecredito !== ""
                                    ? `R$ ${parseFloat(rowItem.limitecredito).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                    : "N/A"}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={FaCity}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Município
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem.municipio}
                                </Text>
                              </Box>
                              {/* Coluna Direita */}
                              <Box>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={FaRegAddressCard}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Endereço
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem.endereco}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={FaShop}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Loja
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem?.["loja  "] || ""}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={FaBarcode}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Código Cliente
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem?.codigo || ""}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={FaBarcode}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Código Vendedor
                                </Text>
                                <Text color="gray.700" mb={3} fontSize="sm">
                                  {rowItem.cod_vend}
                                </Text>
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="#007abe"
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                >
                                  <Icon
                                    as={CiCalendarDate}
                                    mr={1}
                                    color="#c0a316"
                                    size="12px"
                                  />{" "}
                                  Última Compra
                                </Text>
                                <Text color="gray.700" fontSize="sm">
                                  {formatarData(rowItem.ult_compra)}
                                </Text>
                              </Box>
                            </Grid>
                          </Box>
                        )}
                      </GridItem>

                      <GridItem>
                        <Box
                          bg="white"
                          p={6}
                          borderRadius="xl"
                          boxShadow="md"
                          border="1px solid"
                          borderColor="gray.200"
                          h="100%"
                          display="flex"
                          flexDirection="column"
                          _hover={{
                            transform: "translateY(-4px)",
                            boxShadow: "xl",
                            borderColor: "#007abe",
                          }}
                          transition="all 0.3s"
                        >
                          <Text
                            fontSize="lg"
                            fontWeight="bold"
                            color="#007abe"
                            mb={3}
                            display="flex"
                            alignItems="center"
                          >
                            <Icon as={IoEyeSharp} mr={2} color="#c0a316" />{" "}
                            Observação Cliente
                          </Text>
                          <Box
                            bg="gray.50"
                            p={4}
                            color="gray.700"
                            border="1px solid"
                            borderColor="gray.200"
                            height="100px"
                            borderRadius="lg"
                            overflowY="auto"
                            mb={3}
                          >
                            {rowItem.obs_fin || (
                              <Text color="gray.400" fontStyle="italic">
                                Nenhuma observação
                              </Text>
                            )}
                          </Box>
                          <Text
                            fontSize="lg"
                            fontWeight="bold"
                            color="#007abe"
                            mb={3}
                            display="flex"
                            alignItems="center"
                          >
                            <Icon as={IoEyeSharp} mr={2} color="#c0a316" />{" "}
                            Observação de Venda
                          </Text>
                          <Box
                            bg="gray.50"
                            p={4}
                            color="gray.700"
                            border="1px solid"
                            borderColor="gray.200"
                            height="100px"
                            borderRadius="lg"
                            overflowY="auto"
                            mb={3}
                          >
                            {rowItem.obs_venda || (
                              <Text color="gray.400" fontStyle="italic">
                                Nenhuma observação
                              </Text>
                            )}
                          </Box>
                          <Text
                            fontSize="lg"
                            fontWeight="bold"
                            color="#007abe"
                            mb={3}
                            display="flex"
                            alignItems="center"
                          >
                            <Icon as={MdMessage} mr={2} color="#c0a316" />{" "}
                            Itinerário
                          </Text>
                          <Box
                            bg="gray.50"
                            p={4}
                            color="gray.700"
                            border="1px solid"
                            borderColor="gray.200"
                            height="100px"
                            borderRadius="lg"
                            overflowY="auto"
                          >
                            {rowItem.itinerario || (
                              <Text color="gray.400" fontStyle="italic">
                                Nenhum itinerário informado
                              </Text>
                            )}
                          </Box>
                          {/* <Text
                          fontSize="lg"
                          fontWeight="bold"
                          color="black"
                          mb={2}
                          display="flex"
                          alignItems="center"
                        >
                          <Icon as={FaCalendarDays} mr={2} /> Data de Retorno
                        </Text>
                        <Input
                          focusBorderColor="purple.700"
                          type="date"
                          bg="white"
                          color="black"
                          // value={date}
                          placeholder="Apenas números - ddmmaaaa"
                          // onChange={handleChangeInputDate}
                          // borderColor="black"
                        /> */}
                        </Box>
                      </GridItem>

                      <GridItem colSpan={{ base: 1, lg: 2 }}>
                        {isLoading2 ? (
                          <Center h="500px">
                            <Spinner size="xl" color="#007abe" />
                          </Center>
                        ) : (
                          <Box
                            bg="white"
                            p={6}
                            borderRadius="xl"
                            boxShadow="md"
                            border="1px solid"
                            borderColor="gray.200"
                            minH="500px"
                            _hover={{
                              boxShadow: "xl",
                              borderColor: "#007abe",
                            }}
                            transition="all 0.3s"
                          >
                            <Text
                              fontSize="lg"
                              fontWeight="bold"
                              color="#007abe"
                              mb={4}
                              display="flex"
                              alignItems="center"
                            >
                              <Icon as={LuHistory} mr={2} color="#c0a316" />{" "}
                              Histórico de Compras
                            </Text>
                            <Flex
                              direction={{ base: "column", md: "row" }}
                              gap={4}
                              mb={4}
                              align={{ base: "stretch", md: "flex-end" }}
                            >
                              <FormControl maxW={{ base: "100%", md: "200px" }}>
                                <FormLabel
                                  color="#007abe"
                                  fontWeight="semibold"
                                >
                                  Data Inicial
                                </FormLabel>
                                <Input
                                  focusBorderColor="#007abe"
                                  borderColor="gray.300"
                                  fontSize="sm"
                                  type="date"
                                  value={dataInicialEstado}
                                  onChange={(e) =>
                                    setDataInicialEstado(e.target.value)
                                  }
                                  borderRadius="lg"
                                />
                              </FormControl>
                              <FormControl maxW={{ base: "100%", md: "200px" }}>
                                <FormLabel
                                  color="#007abe"
                                  fontWeight="semibold"
                                >
                                  Data Final
                                </FormLabel>
                                <Input
                                  focusBorderColor="#007abe"
                                  borderColor="gray.300"
                                  fontSize="sm"
                                  type="date"
                                  value={dataFinalEstado}
                                  onChange={(e) =>
                                    setDataFinalEstado(e.target.value)
                                  }
                                  borderRadius="lg"
                                />
                              </FormControl>
                              <Button
                                minW={{ base: "100%", md: "120px" }}
                                bg="#007abe"
                                color="white"
                                _hover={{
                                  bg: "#005a8a",
                                  transform: "translateY(-2px)",
                                  boxShadow: "md",
                                }}
                                isLoading={isLoading}
                                onClick={handleSubmit}
                                borderRadius="lg"
                                transition="all 0.2s"
                              >
                                Buscar
                              </Button>
                              <Button
                                minW={{ base: "100%", md: "180px" }}
                                bg="#c0a316"
                                color="white"
                                _hover={{
                                  bg: "#9d8011",
                                  transform: "translateY(-2px)",
                                  boxShadow: "md",
                                }}
                                onClick={() =>
                                  setShowTipo(
                                    showTipo === "NF" ? "Pedidos" : "NF",
                                  )
                                }
                                leftIcon={<BiShow />}
                                borderRadius="lg"
                                transition="all 0.2s"
                              >
                                Mostrar {showTipo === "NF" ? "Pedidos" : "NF"}
                              </Button>
                            </Flex>
                            <Box
                              p={2}
                              overflowY="auto"
                              maxHeight="450px"
                              borderRadius="lg"
                              border="1px solid"
                              borderColor="gray.200"
                              sx={{
                                "&::-webkit-scrollbar": {
                                  width: "8px",
                                  height: "8px",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor: "#007abe",
                                  borderRadius: "4px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                  backgroundColor: "#005a8a",
                                },
                              }}
                            >
                              <TabelaPedidos pedidos={pedidosFiltrados} />
                            </Box>
                          </Box>
                        )}
                        <Modal
                          isOpen={isOpen}
                          onClose={onClose}
                          size="6xl"
                          isCentered
                        >
                          <ModalOverlay />
                          <ModalContent>
                            <ModalHeader bg="#007abe" color="white">
                              <Flex align="center">
                                <FcDocument />
                                <Text ml={2}>
                                  Detalhes -{" "}
                                  {showTipo === "NF" ? "NF" : "Pedido"}
                                </Text>
                              </Flex>
                            </ModalHeader>

                            <ModalCloseButton color="white" />
                            <ModalBody overflowY="auto">
                              {selectedPedido && (
                                <>
                                  {selectedPedido.itens.length > 0 ? (
                                    <Table variant="striped" colorScheme="gray">
                                      <Thead>
                                        <Tr>
                                          <Th>Descrição</Th>
                                          <Th>Código Produto</Th>
                                          <Th>Valor Unitário</Th>
                                          <Th>Quantidade</Th>
                                          <Th>Volume</Th>
                                        </Tr>
                                      </Thead>
                                      <Tbody>
                                        {selectedPedido.itens.map(
                                          (item, index) => (
                                            <Tr key={index}>
                                              <Td>{item.descricao_produto}</Td>
                                              <Td>{item.cod_produto}</Td>
                                              <Td>
                                                {item.preco_unitario.toFixed(2)}
                                              </Td>
                                              <Td>{item.qtde_produto}</Td>
                                              <Td>{item.volume_produto}</Td>
                                            </Tr>
                                          ),
                                        )}
                                      </Tbody>
                                    </Table>
                                  ) : (
                                    <p>
                                      Não foi encontrado nenhum registro na data
                                      informada
                                    </p>
                                  )}
                                </>
                              )}
                            </ModalBody>
                            <ModalFooter>
                              <Button
                                colorScheme="red"
                                variant="outline"
                                mr={3}
                                onClick={onClose}
                              >
                                Fechar
                              </Button>
                            </ModalFooter>
                          </ModalContent>
                        </Modal>
                      </GridItem>
                      {/* <GridItem colSpan={1}>
                        <Box
                          bg="white"
                          _hover={{
                            boxShadow: "lg",
                            borderColor: "black",
                            transform: "scale(1.01)",
                          }} // border="1px"
                          p="4"
                          borderRadius="10px"
                          minW="350px"
                          minH="605px"
                          shadow="lg"
                        >
                          <Text
                            fontSize="lg"
                            fontWeight="bold"
                            color="black"
                            mb={2}
                            display="flex"
                            alignItems="center"
                          >
                            <Icon as={LuHistory} mr={2} /> Histórico de Compras:
                          </Text>
                        </Box>
                      </GridItem> */}
                    </Grid>
                  </>
                )}
              </TabPanel>
              <TabPanel>
                {abaAtiva === 1 && rowItem && (
                  <Box
                    bg="white"
                    borderRadius="10px"
                    minH="605px"
                    shadow="lg"
                    display="flex"
                    flexDirection="column"
                    overflow="hidden"
                  >
                    <Box borderBottom="1px solid" borderColor="gray.200">
                      <Box
                        bg="gray.50"
                        px={{ base: 4, md: 5 }}
                        py={4}
                        borderTopRadius="10px"
                      >
                        <Flex
                          direction={{ base: "column", xl: "row" }}
                          gap={5}
                          align={{ xl: "center" }}
                        >
                          <HStack spacing={3} flexShrink={0}>
                            <Box>
                              <Text
                                fontSize="lg"
                                fontWeight="bold"
                                color="gray.800"
                                lineHeight="short"
                              >
                                Consulta de Títulos
                              </Text>
                            </Box>
                          </HStack>

                          <HStack
                            bg="white"
                            px={4}
                            py={3}
                            borderRadius="lg"
                            border="1px solid"
                            borderColor="gray.200"
                            shadow="sm"
                            spacing={4}
                            align="flex-end"
                            flexShrink={0}
                            w={{ base: "full", xl: "auto" }}
                          >
                            <FormControl
                              maxW={{ base: "full", sm: "150px" }}
                              minW="130px"
                            >
                              <FormLabel
                                color="#007abe"
                                fontWeight="semibold"
                                fontSize="xs"
                                mb={1}
                                textTransform="uppercase"
                                letterSpacing="wider"
                              >
                                Data Inicial
                              </FormLabel>
                              <Input
                                focusBorderColor="#007abe"
                                borderColor="gray.300"
                                bg="gray.50"
                                fontSize="sm"
                                type="date"
                                value={dataInicial2}
                                onChange={(e) =>
                                  setDataInicial2(e.target.value)
                                }
                                borderRadius="lg"
                                _hover={{ borderColor: "#007abe" }}
                              />
                            </FormControl>
                            <Divider
                              orientation="vertical"
                              h="36px"
                              display={{ base: "none", sm: "block" }}
                              borderColor="gray.200"
                            />
                            <FormControl
                              maxW={{ base: "full", sm: "150px" }}
                              minW="130px"
                            >
                              <FormLabel
                                color="#007abe"
                                fontWeight="semibold"
                                fontSize="xs"
                                mb={1}
                                textTransform="uppercase"
                                letterSpacing="wider"
                              >
                                Data Final
                              </FormLabel>
                              <Input
                                focusBorderColor="#007abe"
                                borderColor="gray.300"
                                bg="gray.50"
                                fontSize="sm"
                                type="date"
                                value={dataFinal2}
                                onChange={(e) => setDataFinal2(e.target.value)}
                                borderRadius="lg"
                                _hover={{ borderColor: "#007abe" }}
                              />
                            </FormControl>
                          </HStack>

                          <Flex
                            gap={2}
                            wrap="wrap"
                            w={{ base: "full", xl: "auto" }}
                            flex={{ xl: 1 }}
                            justify={{ base: "stretch", xl: "flex-end" }}
                          >
                            <Button
                              {...getTitulosBtnProps("Títulos Abertos")}
                              onClick={() =>
                                handleSubmit3("A", "Títulos Abertos")
                              }
                            >
                              <Icon as={FcDocument} mr={2} /> Títulos Abertos
                            </Button>
                            <Button
                              {...getTitulosBtnProps("Títulos Baixados")}
                              onClick={() =>
                                handleSubmit3("", "Títulos Baixados")
                              }
                            >
                              <Icon as={FcFinePrint} mr={2} /> Títulos Baixados
                            </Button>
                            <Button
                              {...getTitulosBtnProps("Títulos Faturados")}
                              onClick={() =>
                                handleSubmit3("F", "Títulos Faturados")
                              }
                            >
                              <Icon as={FcDocument} mr={2} /> Títulos Faturados
                            </Button>
                          </Flex>
                        </Flex>
                      </Box>

                      {(modalTitle || isLoading3) && (
                        <Flex
                          px={{ base: 4, md: 5 }}
                          py={2.5}
                          bgGradient="linear(to-r, #007abe, #005a8a)"
                          color="white"
                          align="center"
                          justify="space-between"
                          flexWrap="wrap"
                          gap={2}
                        >
                          <HStack spacing={2}>
                            <Box color="whiteAlpha.900">
                              <FcComboChart />
                            </Box>
                            <Text fontSize="sm" fontWeight="bold">
                              {isLoading3 && !modalTitle
                                ? "Consultando títulos..."
                                : modalTitle}
                            </Text>
                          </HStack>
                          {Array.isArray(responseData) &&
                            responseData.length > 0 &&
                            !isLoading3 && (
                              <Badge
                                bg="whiteAlpha.300"
                                color="white"
                                px={3}
                                py={1}
                                borderRadius="full"
                                fontSize="xs"
                                fontWeight="semibold"
                                textTransform="none"
                              >
                                {responseData.length} registro
                                {responseData.length !== 1 ? "s" : ""}
                              </Badge>
                            )}
                        </Flex>
                      )}
                    </Box>
                    <Box
                      flex="1"
                      overflow="auto"
                      sx={{
                        "&::-webkit-scrollbar": {
                          width: "8px",
                          height: "8px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#007abe",
                          borderRadius: "4px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          backgroundColor: "#005a8a",
                        },
                        "&::-webkit-scrollbar-track": {
                          backgroundColor: "transparent",
                        },
                      }}
                    >
                      {isLoading3 ? (
                        <Center py={20}>
                          <Spinner size="xl" color="#007abe" />
                        </Center>
                      ) : !modalTitle ? (
                        <Center py={20} px={4}>
                          <Text color="gray.500" textAlign="center">
                            Selecione o período e um tipo de título para
                            consultar.
                          </Text>
                        </Center>
                      ) : responseData ? (
                        Array.isArray(responseData) &&
                        responseData.length > 0 ? (
                          <Box overflow="auto" p={4}>
                            <Table variant="simple" size="sm">
                              <Thead
                                bg="#007abe"
                                position="sticky"
                                top={0}
                                zIndex={10}
                              >
                                <Tr>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Código
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Loja
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Vendedor
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Razão Social
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    CNPJ
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Título
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Parcela
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Tipo
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Emissão
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Vencimento
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Data Baixa
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Atraso
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Valor Original
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                    borderRight="1px solid"
                                    borderColor="rgba(255, 255, 255, 0.2)"
                                  >
                                    Valor Pago
                                  </Th>
                                  <Th
                                    color="white"
                                    fontWeight="bold"
                                    textTransform="uppercase"
                                    fontSize="xs"
                                    px={3}
                                    py={3}
                                  >
                                    Valor Saldo
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {Array.isArray(responseData) &&
                                responseData.length > 0 ? (
                                  responseData.map((item, index) => {
                                    const vencimentoDate = removeTimeFromDate(
                                      parseDate2(item.vencimento),
                                    );

                                    return (
                                      <Tr
                                        key={index}
                                        _hover={{
                                          bg: "gray.50",
                                        }}
                                        transition="all 0.2s"
                                      >
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.codigo}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.loja}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.vendedor}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.razao_social}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.cnpj}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.titulo}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.parcela}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.tipo}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.emissao}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                          borderRadius={
                                            vencimentoDate < currentDate &&
                                            item.dt_baixa === "  /  /    "
                                              ? "md"
                                              : ""
                                          }
                                          bg={
                                            vencimentoDate < currentDate &&
                                            item.dt_baixa === "  /  /    "
                                              ? "red.500"
                                              : "transparent"
                                          }
                                          color={
                                            vencimentoDate < currentDate &&
                                            item.dt_baixa === "  /  /    "
                                              ? "white"
                                              : "inherit"
                                          }
                                          fontWeight={
                                            vencimentoDate < currentDate &&
                                            item.dt_baixa === "  /  /    "
                                              ? "bold"
                                              : "normal"
                                          }
                                        >
                                          {item.vencimento}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.dt_baixa}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                        >
                                          {item.dias_atraso}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                          fontWeight="semibold"
                                        >
                                          {new Intl.NumberFormat("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                          }).format(item.valor_original)}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                          fontWeight="semibold"
                                        >
                                          {new Intl.NumberFormat("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                          }).format(item.valor_pago)}
                                        </Td>
                                        <Td
                                          px={3}
                                          py={2}
                                          borderBottom="1px solid"
                                          borderColor="gray.100"
                                          fontWeight="semibold"
                                          color="#c0a316"
                                        >
                                          {new Intl.NumberFormat("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                          }).format(item.valor_saldo)}
                                        </Td>
                                      </Tr>
                                    );
                                  })
                                ) : responseData.errorMessage ||
                                  responseData.message ? (
                                  <Tr>
                                    <Td
                                      colSpan={15}
                                      textAlign="center"
                                      py={8}
                                      color="gray.500"
                                    >
                                      {responseData.errorMessage ||
                                        responseData.message}
                                    </Td>
                                  </Tr>
                                ) : (
                                  <Tr>
                                    <Td
                                      colSpan={15}
                                      textAlign="center"
                                      py={8}
                                      color="gray.500"
                                    >
                                      Carregando...
                                    </Td>
                                  </Tr>
                                )}

                                {Array.isArray(responseData) &&
                                  responseData.length > 0 && (
                                    <Tr bg="gray.50">
                                      <Td
                                        colSpan={4}
                                        fontWeight="bold"
                                        color="#007abe"
                                        px={3}
                                        py={3}
                                        borderTop="2px solid"
                                        borderColor="#007abe"
                                        textAlign="right"
                                      >
                                        Total de Títulos:
                                      </Td>
                                      <Td
                                        fontWeight="bold"
                                        color="#007abe"
                                        px={3}
                                        py={3}
                                        borderTop="2px solid"
                                        borderColor="#007abe"
                                      >
                                        {responseData.length}
                                      </Td>
                                      <Td
                                        colSpan={2}
                                        fontWeight="bold"
                                        color="#007abe"
                                        px={3}
                                        py={3}
                                        borderTop="2px solid"
                                        borderColor="#007abe"
                                        textAlign="right"
                                      >
                                        Total de Títulos Vencidos:
                                      </Td>
                                      <Td
                                        fontWeight="bold"
                                        color="#007abe"
                                        px={3}
                                        py={3}
                                        borderTop="2px solid"
                                        borderColor="#007abe"
                                      >
                                        {filteredItemsCount}
                                      </Td>
                                      <Td
                                        colSpan={4}
                                        borderTop="2px solid"
                                        borderColor="#007abe"
                                      ></Td>
                                      <Td
                                        fontWeight="bold"
                                        color="#007abe"
                                        px={3}
                                        py={3}
                                        borderTop="2px solid"
                                        borderColor="#007abe"
                                      >
                                        {new Intl.NumberFormat("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        }).format(
                                          responseData.reduce(
                                            (total, item) =>
                                              total + item.valor_original,
                                            0,
                                          ),
                                        )}
                                      </Td>
                                      <Td
                                        fontWeight="bold"
                                        color="#007abe"
                                        px={3}
                                        py={3}
                                        borderTop="2px solid"
                                        borderColor="#007abe"
                                      >
                                        {new Intl.NumberFormat("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        }).format(
                                          responseData.reduce(
                                            (total, item) =>
                                              total + item.valor_pago,
                                            0,
                                          ),
                                        )}
                                      </Td>
                                      <Td
                                        fontWeight="bold"
                                        color="#c0a316"
                                        px={3}
                                        py={3}
                                        borderTop="2px solid"
                                        borderColor="#007abe"
                                      >
                                        {new Intl.NumberFormat("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        }).format(
                                          responseData.reduce(
                                            (total, item) =>
                                              total + item.valor_saldo,
                                            0,
                                          ),
                                        )}
                                      </Td>
                                    </Tr>
                                  )}
                              </Tbody>
                            </Table>
                          </Box>
                        ) : (
                          <Box p={8} textAlign="center">
                            <Text color="gray.500">
                              {responseData.errorMessage ||
                                responseData.message ||
                                "Não foram encontrados registros"}
                            </Text>
                          </Box>
                        )
                      ) : (
                        <Box p={8} textAlign="center">
                          <Text color="gray.500">Carregando...</Text>
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
              </TabPanel>
              <TabPanel px={0}>
                {rowItem && (
                  <Flex direction="column" gap={6}>
                    <LancamentoPedidoPanel
                      rowItem={rowItem}
                      valoresSelecionados={valoresSelecionados}
                      veiculoSelecionado={veiculoSelecionado}
                      onVeiculoChange={setVeiculoSelecionado}
                      motoristaNome={motoristaNome}
                      motoristaId={motoristaId}
                      onMotoristaNomeChange={setMotoristaNome}
                      onMotoristaChange={handleMotoristaFromFrota}
                      onVolumeBocasChange={setVolumeBocas}
                      parsedCondPagamentos={parsedCondPagamentos}
                      parsedVendedores={parsedVendedores}
                      parsedTransportadoras={parsedTransportadoras}
                      condPagamentoSelecionado={condPagamentoSelecionado}
                      onCondPagamentoChange={handleCondPagamentoChange}
                      showAdditionalInputs={showAdditionalInputs}
                      gerarBoleto={gerarBoleto}
                      onGerarBoletoChange={setGerarBoleto}
                      lacres={lacres}
                      onLacreChange={handleLacreChange}
                      onAddLacre={handleAddLacre}
                      onRemoveLacre={handleRemoveLacre}
                      tipoSaida={tipoSaida}
                      onTipoSaidaChange={setTipoSaida}
                      parcelasVencimento={parcelasVencimento}
                      onParcelasVencimentoChange={setParcelasVencimento}
                      operacaoSelecionada={operacaoSelecionada}
                      onOperacaoChange={handleOperacao}
                      tipoFreteSelecionado={tipoFreteSelecionado}
                      onTipoFreteChange={handleTipoFrete}
                      transportadoraSelecionado={transportadoraSelecionado}
                      onTransportadoraChange={handleTransportadora}
                      obsAtendimentoSelecionada={obsAtendimentoSelecionada}
                      onObsAtendimentoChange={handleObsAtendimento}
                      selectedVendedor={selectedVendedor}
                      onVendedorChange={handleSelectChangeVendedores}
                      tipoOperacaoOptions={tipoOperacaoOptions}
                      tipoFreteOptions={tipoFreteOptions}
                    />
                    <CarrinhoProdutosAtendimento
                      valoresSelecionados={valoresSelecionados}
                      onChangeCarrinho={handleFinalizarAddProdutos}
                    />
                  </Flex>
                )}
              </TabPanel>
            </TabPanels>
          </Tabs>

          <Tooltip
            label={messages.map((msg, index) => (
              <div key={index}>{msg}</div>
            ))}
            isDisabled={!disabled}
            hasArrow
            bg="red.300"
          >
            <Button
              w="100%"
              mt={6}
              mb={2}
              bg="#c0a316"
              color="white"
              isDisabled={disabled}
              onClick={handleClickFinalizaAtendimento}
              isLoading={isLoading}
              spinner={<BeatLoader size={8} color="white" />}
              _hover={{
                bg: "#9d8011",
                transform: "translateY(-2px)",
                boxShadow: "xl",
              }}
              _disabled={{
                bg: "gray.300",
                cursor: "not-allowed",
              }}
              borderRadius="lg"
              size="lg"
              fontWeight="bold"
              transition="all 0.2s"
            >
              Enviar Pedido
            </Button>
          </Tooltip>
          {errorMessage && (
            <Box mt={4}>
              <Alert status="error" borderRadius="md">
                <AlertIcon />
                <Box flex="1">
                  <strong>Código:</strong> {errorMessage.code} <br />
                  <strong>Mensagem:</strong> {errorMessage.message}
                </Box>
              </Alert>
            </Box>
          )}
          {pedidoFinalizado && (
            <Alert
              status="success"
              variant="subtle"
              borderRadius="lg"
              mt={4}
              flexDirection={{ base: "column", md: "row" }}
              alignItems={{ base: "stretch", md: "center" }}
            >
              <AlertIcon />
              <Box flex="1" py={1}>
                <Text fontWeight="bold">
                  Pedido de venda gerado com sucesso
                </Text>
                <Text fontSize="md" mt={1}>
                  Número do pedido:{" "}
                  <Text as="span" fontWeight="bold" color="#007abe" fontSize="xl">
                    {pedidoFinalizado}
                  </Text>
                </Text>
              </Box>
              <Button
                size="sm"
                bg="#007abe"
                color="white"
                _hover={{ bg: "#005a8a" }}
                onClick={irParaHome}
                leftIcon={<GoHome />}
                flexShrink={0}
              >
                Ir para início
              </Button>
            </Alert>
          )}
        </Box>
      </Box>
      <Footer />
    </Flex>
  );
};

export default Atendimento1;
